























import useConfig from "@/shared/composition/useConfig";
import useStore from "@/shared/composition/useStore";
import contenidoVue from "../contenido.vue";
import useContenido from "./useContenido";

import {
  defineComponent,
  ref,
  onMounted,
  toRefs,
  watch,
  computed,
  Ref,
} from "@vue/composition-api";
import { router } from "@/shared/router";
import useValores from "@/shared/composition/useValores";
import autocompleteVue from "./autocomplete.vue";

export default defineComponent({
  name: "ContenedorCargador",
  props: {
    vistaPath: String,
    query: Object,
    esDialogo: Boolean,
  },
  components: {
    Contenido: contenidoVue,
    Autocomplete: autocompleteVue,
  },
  setup(props, { emit, root }) {
    const { baseUrl } = useConfig();
    const { vistaPath } = toRefs(props);
    const path = computed(() => vistaPath.value.split("/"));

    const {
      data,
      cargar: cargarData,
      cargando,
      dataOriginal,
    } = useContenido({
      url: baseUrl.value,
      modelo: { nombre: "nombre" },
      dataPath: "0.data",
    });

    const idContenido = computed(() => path.value[0]);
    const { valor: store } = useStore(idContenido);

    const contenido = computed(() => {
      return data.value || store.value;
    });

    const cargar = async () => {
      await cargarData({ nombre: idContenido.value });

      // guardar en local storage
      store.value = contenido.value;
    };

    onMounted(cargar);
    watch(vistaPath, () => {
      dataOriginal.value = null;
      cargar();
    });

    const subContenido: Ref<Record<string, any>> = ref({});
    const showDialogo = ref(false);
    const dialogData = ref({});
    const dialogKey = ref(0);

    const abrir = ({ config, query }) => {
      console.log("abrir con:", { config, query });

      const { asignarDesdeObj } = useValores(query);
      query = asignarDesdeObj(config.modelo);

      dialogKey.value += 1;
      subContenido.value = {
        ...config,
      };

      if (subContenido.value.dialogo) {
        showDialogo.value = true;
      } else {
        // router.push o replace
        router.push({ path: "/vista/" + config.path, query });
      }
    };

    const cerrar = (data = {}) => {
      console.log("cerrar ejecutado con", { data });
      dialogData.value = data;
      showDialogo.value = false;
    };

    return {
      contenido,
      cargando,
      rutas: computed(() => path.value.slice(1)),
      subContenido,
      abrir,
      cerrar,
      showDialogo,
      emitirCerrar: (data) => emit("cerrar", data),
      dialogData,
      dialogKey
    };
  },
});
